// extracted by mini-css-extract-plugin
export default {"threeDots":"VideoMenuButton-module__threeDots_vVjyt"};